<template>
  <div class="col-span-2 px-4 sm:px-0">
    <!-- Tabs -->
    <div class="flex items-center gap-6 sm:gap-10 border-b overflow-x-auto">
      <button @click="activeTab = 'highlight'" :class="tabClass('highlight')">HIGHLIGHTS</button>

      <button @click="activeTab = 'archive'" :class="tabClass('archive')">ARCHIVE</button>
    </div>

    <!-- Content -->
    <div class="py-6 sm:py-8">
      <ul v-if="activeTab === 'highlight'" class="space-y-4 sm:space-y-6">
        <li class="rounded-lg text-gray-600 text-sm sm:text-base">
          <ul>
            <li v-for="(item, index) in itemHighlights" :key="index" class="max-h-auto">
              <div class="flex gap-4">
                <!-- Image -->
                <img
                  :src="`https://iwcdeped.com/gazetteimages/${item.filename}`"
                  alt="Banner"
                  class="h-40 w-48 rounded-lg object-cover flex-shrink-0"
                />

                <!-- Content -->
                <router-link
                  :to="`/portal/home/article/${encryptFile(item.id)}`"
                  class="space-y-2 flex-1"
                >
                  <h1 class="text-xl font-semibold text-gray-900">
                    {{ item.title }}
                  </h1>

                  <h2 class="text-xs text-zinc-500">
                    {{ renderDateTimeFormat(item.createdAt) }}
                  </h2>

                  <!-- Content Preview -->
                  <div
                    class="text-sm text-zinc-700 break-words transition-all duration-300"
                    :class="expanded[index] ? '' : 'line-clamp-3'"
                    v-html="sanitizeHtml(item.content)"
                  ></div>

                  <!-- Read More Toggle -->
                  <button
                    v-if="isLongContent(item.content)"
                    @click="toggleExpand(index)"
                    class="text-sm font-medium text-blue-600 hover:text-blue-800 transition"
                  >
                    {{ expanded[index] ? 'Read less...' : 'Read more...' }}
                  </button>
                </router-link>
              </div>

              <!-- Enhanced Divider -->
              <hr
                class="my-6 border-0 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"
              />
            </li>
          </ul>
        </li>
      </ul>

      <ul v-else class="space-y-4 sm:space-y-6">
        <li class="rounded-lg shadow-sm">
          <ul class="divide-y">
            <li
              class="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-50 transition"
            >
              <h1 class="text-base sm:text-lg font-semibold text-gray-800">General Assembly</h1>
              <span class="text-gray-400 text-lg">&gt;</span>
            </li>

            <li
              class="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-50 transition"
            >
              <h1 class="text-base sm:text-lg font-semibold text-gray-800">Social Gathering</h1>
              <span class="text-gray-400 text-lg">&gt;</span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import reusableBase from '@/utils/reusables/dateFormat';
import encryptHandler from '@/utils/encrypt';
import { inject, onMounted, ref } from 'vue';
import DOMPurify from 'dompurify';
export default {
  name: 'HighlightArchiveTabs',
  setup() {
    const axios = inject('$axios');
    const activeTab = ref('highlight');
    const itemHighlights = ref([]);
    const expanded = ref({});
    const { renderDateTimeFormat } = reusableBase();
    const { encryptFile } = encryptHandler();
    const tabClass = (tab) => {
      return `
        font-subheader font-medium 
        text-base sm:text-2xl md:text-3xl
        pb-2 transition whitespace-nowrap
        ${
          activeTab.value === tab
            ? 'text-secondaryPalette border-b-4 border-secondaryPalette'
            : 'text-gray-400 hover:text-secondaryPalette'
        }
      `;
    };
    onMounted(() => {
      fetchHighlights();
    });
    const toggleExpand = (index) => {
      expanded.value[index] = !expanded.value[index];
    };

    const isLongContent = (content) => {
      return content && content.length > 100;
    };

    const fetchHighlights = async () => {
      try {
        const result = await axios.get(`/api/articles`, {
          params: {
            highlight: true
          }
        });
        console.log(result.data.data);
        itemHighlights.value = result.data.data;
      } catch (error) {
        console.log('render', error);
      }
    };
    const sanitizeHtml = (html) => {
      if (!html) return '';

      // Remove &nbsp;
      html = html.replace(/&nbsp;/g, ' ');

      // Remove multiple spaces
      html = html.replace(/\s{2,}/g, ' ');

      // Remove empty paragraphs like <p><br></p>
      html = html.replace(/<p>(\s|<br\s*\/?>)*<\/p>/gi, '');

      // Trim leading & trailing spaces
      html = html.trim();

      return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
    };

    return {
      activeTab,
      tabClass,
      fetchHighlights,
      itemHighlights,
      sanitizeHtml,
      toggleExpand,
      isLongContent,
      expanded,
      encryptFile,
      renderDateTimeFormat
    };
  }
};
</script>
